import React from 'react';
import { useNavigate } from 'react-router-dom';
import './blogs.css';
import { blogs, articles } from '../../blogsData';

const formatDate = (iso?: string) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
};

const Blogs: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="blogs section" id="blogs">
      <div className="section__header">
        <h2 className="section__title">Writing</h2>
        <span className="section__subtitle">Blogs and articles</span>
      </div>

      <div className="blogs__container container">

        {/* ── My Writing ─────────────────────────────────────────────── */}
        {blogs.length > 0 && (
          <div className="blogs__feed">
            <p className="blogs__feed-label">From me</p>
            <ul className="blogs__list">
              {blogs.map((blog, i) => (
                <li
                  key={blog.slug}
                  className={`blogs__item${i === 0 ? ' blogs__item--featured' : ''}`}
                  onClick={() => navigate(`/blogs/${blog.slug}`)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && navigate(`/blogs/${blog.slug}`)}
                >
                  <div className="blogs__item-content">
                    <time className="blogs__item-date">{formatDate(blog.date)}</time>
                    <h3 className="blogs__item-title">{blog.title}</h3>
                    <p className="blogs__item-desc">{blog.description}</p>
                    <div className="blogs__item-footer">
                      {blog.readTime && (
                        <span className="blogs__item-readtime">{blog.readTime}</span>
                      )}
                      <span className="blogs__item-cta">Read →</span>
                    </div>
                  </div>
                  {blog.cover && (
                    <div className="blogs__item-thumb">
                      <img src={blog.cover} alt="" />
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* ── Articles ───────────────────────────────────────────────── */}
        {articles.length > 0 && (
          <div className="blogs__feed">
            <p className="blogs__feed-label">Worth reading</p>
            <ul className="blogs__list">
              {articles.map(article => (
                <li className="blogs__item blogs__item--article" key={article.url}>
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blogs__item-link"
                  >
                    <div className="blogs__item-content">
                      <div className="blogs__item-meta">
                        {article.source && (
                          <span className="blogs__item-source">{article.source}</span>
                        )}
                        {article.date && (
                          <time className="blogs__item-date">{formatDate(article.date)}</time>
                        )}
                      </div>
                      <h3 className="blogs__item-title">{article.title}</h3>
                      <p className="blogs__item-desc">{article.description}</p>
                      <div className="blogs__item-footer">
                        <span className="blogs__item-cta">Read on source ↗</span>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

      </div>
    </section>
  );
};

export default Blogs;
